import styled from "styled-components";

export const AboutSection = styled.div`
    background: #fdfdfd;
    padding: 8rem 5%;
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #333;
`;

export const HeadingText = styled.h2`
    font-size: 3.5rem;
    font-weight: 700;
    margin-bottom: 3rem;
    color: #000;
    span {
        color: #fca311;
        margin-left: 10px;
    }
    
    @media (max-width: 768px) {
        font-size: 2.8rem;
    }
`;

export const AboutContainer = styled.div`
    max-width: 900px;
    width: 100%;
    text-align: center;
    background: #fff;
    padding: 4rem;
    border-radius: 10px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);

    @media (max-width: 768px) {
        padding: 2.5rem;
    }
`;

export const SubTitle = styled.h3`
    font-size: 2.2rem;
    font-weight: 600;
    margin-bottom: 2rem;
    color: #fca311;
`;

export const Paragraph = styled.p`
    font-size: 1.6rem;
    line-height: 1.8;
    color: #555;
    margin-bottom: 2rem;
    
    &:last-child {
        margin-bottom: 0;
        font-weight: 500;
        color: #000;
        font-size: 1.7rem;
    }

    @media (max-width: 768px) {
        font-size: 1.4rem;
        line-height: 1.6;
    }
`;